import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Button.module.css';

const Button = ({ children, to, onClick, variant = 'primary', className = '', type = 'button', ...props }) => {
  const btnClass = `${styles.btn} ${styles[variant]} ${className}`;

  if (to) {
    return (
      <Link to={to} className={btnClass} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={btnClass} {...props}>
      {children}
    </button>
  );
};

export default Button;
